module.exports = __webpack_public_path__ + "img/87efd37.jpg";